import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { CustomAvatarComponent } from "../../../../shared/components/custom-avatar/custom-avatar.component";
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { UserInitialsService } from '../../../../core/services/user-initials.service';
import { UserDataService } from '../../../../core/services/user-data.service';
import { combineLatest } from 'rxjs';
import { ProfileImageService } from '../../../../core/services/profile-image.service';

@Component({
  selector: 'app-user-banner',
  standalone: true,
  imports: [CustomButtonComponent, CustomAvatarComponent, TranslocoPipe],
  templateUrl: './user-banner.component.html',
  styleUrl: './user-banner.component.css'
})
export class UserBannerComponent {
  name: string = `${this.userData.getUser()?.first_name ?? ''} ${this.userData.getUser()?.last_name ?? ''}`;
  role: string = this.userData.getUser()?.role ?? '';

  rolesOptions: string[] = [];
  serverRoleOptions: string[] = [];

  @Input() editing: boolean = false;
  @Output() shareButtonClick = new EventEmitter<void>();
  @Output() editButtonClick = new EventEmitter<void>();

  // User initials or image
  get userInitials(): string {
    return this.userInitialsService.getUserInitials(this.userData.getUser()?.first_name ?? '', this.userData.getUser()?.last_name ?? '');
  }

  get getProfileImage(): string | null {
    return this.profileImage.getProfileImage();
  }

  constructor(private userInitialsService: UserInitialsService, private userData: UserDataService, private translocoService: TranslocoService, private profileImage: ProfileImageService) {
    const roleKeys = [
      'shared.roles.admin',
      'shared.roles.manager',
      'shared.roles.sr_manager',
      'shared.roles.director'
    ];

    combineLatest(roleKeys.map((key) => this.translocoService.selectTranslate(key))).subscribe((translations) => {
      this.rolesOptions = translations;

      this.resetData();
    });
  }

  onShareClick(): void {
    this.shareButtonClick.emit();
  }

  onEditClick(): void {
    this.editButtonClick.emit();
    this.resetData();
  }

  resetData() {
    // Populate main data
    this.name = `${this.userData.getUser()?.first_name ?? ''} ${this.userData.getUser()?.last_name ?? ''}`;
    this.role = this.userData.getUser()?.role ?? '';
    this.profileImage.refreshProfileImage();

    // Populate with translated user role
    this.serverRoleOptions = ["ADMIN", "MANAGER", "SR_MANAGER", "DIRECTOR"];
    const selectedRole = this.serverRoleOptions.indexOf(this.userData.getUser()?.role ?? '');
    const translatedRole = this.rolesOptions.at(selectedRole);
    if (translatedRole) {
      this.role = translatedRole;
    }
  }
}
